<template>
    <NuxtLink
        v-if="job"
        :to="`/praca/${job.slug || slug}`"
        class="not-prose my-8 flex flex-col gap-4 rounded-2xl border border-orange-200 bg-orange-50/60 p-5 no-underline transition hover:border-orange-300 hover:shadow-md sm:flex-row sm:items-center"
    >
        <CThumbnailImage
            :alt="`${job.orgMeta?.title} logo`"
            class="size-14 shrink-0 rounded-xl bg-white dark:bg-surface-card"
            :src="job.orgMeta?.image"
            type="job"
        />
        <div class="min-w-0 flex-1">
            <p class="text-xs font-semibold uppercase tracking-wide text-[#f97316]">Pracovná ponuka</p>
            <p class="mt-1 text-xl font-bold leading-tight text-gray-900 dark:text-txt-headings">{{ job.title }}</p>
            <p class="mt-1 text-sm text-gray-600 dark:text-txt-body">
                {{ [job.orgMeta?.title, placeText, salaryText].filter(Boolean).join(' · ') }}
            </p>
        </div>
        <span class="inline-flex shrink-0 items-center justify-center gap-2 rounded-xl bg-[#f97316] px-5 py-3 text-sm font-semibold text-white">
            Pozrieť ponuku
            <span aria-hidden="true">→</span>
        </span>
    </NuxtLink>
    <!-- Draft, deleted or failed job: keep the author's original link paragraph -->
    <div v-else v-html="fallbackHtml" />
</template>

<script setup lang="ts">
import type { Job } from '#shared/types/Job'
import { formatJobPlaceShort, formatJobSalaryShort } from '@/utils/jobCardText'

interface Props {
    slug: string
    /** The original `<p><a href="/praca/...">` markup, shown when the job can't be loaded. */
    fallbackHtml: string
}

const props = defineProps<Props>()

const { data } = await useFetch<{ job: Job | null; locked?: boolean }>(`/api/jobs/${props.slug}`, {
    key: `blog-job-card-${props.slug}`
})

const job = computed(() => (data.value?.locked ? null : data.value?.job ?? null))

const placeText = computed(() => (job.value ? formatJobPlaceShort(job.value) : ''))
const salaryText = computed(() => (job.value ? formatJobSalaryShort(job.value) : ''))
</script>
